import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import {
  createPreference,
  deletePreference,
  getAllPreference,
  getOnePreference,
  updatePreference,
} from "../../helper/apicalls/preference";
import "../../styles/admin/preference.scss";
import CourseCard from "./courseCard";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import CreatePreference from "./createPreference";
import DeleteConfirmPopUp from "../common/deleteConfirmPopUp";
import GlobalLoader from "../common/GlobalLoader";
import { useOutletContext } from "react-router-dom";

const Preference = () => {
  const auth_token = Cookies.get("admin_token");
  const { setHeaderName, searchQuery, setIsShowSearch } = useOutletContext();

  const [preferenceList, setPreferenceList] = useState([]);
  const [isShowCreatePreference, setIsShowCreatePreference] = useState(false);
  const [editableData, setEditableData] = useState([]);
  const [isEditable, setIsEditable] = useState(false);
  const [isConfirmDeleteOpen, setIsConfirmDeleteOpen] = useState(false);
  const [selectedPreference, setSelectedPreference] = useState(null);
  const [isViewable, setIsViewable] = useState(false);
  const [loader, setLoader] = useState(false);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);

  const fetchPreferenceData = async () => {
    setLoader(true);

    const params = {};
    if (debouncedSearch.trim()) params.search = debouncedSearch.trim();
    try {
      const res = await getAllPreference(auth_token, params);
      setPreferenceList(res?.data || []);
      const tp =
        Number(res?.total_pages) ||
        (Number(res?.total) && Math.ceil(Number(res.total) / limit)) ||
        1;
    } catch (err) {
      console.error(err);
    } finally {
      setLoader(false);
    }
  };

  const handleEditPreference = async (data) => {
    setIsEditable(true);
    setIsShowCreatePreference(true);
    setLoader(true);
    try {
      const res = await getOnePreference(auth_token, data?.id);
      setEditableData(res);
    } catch (err) {
      console.error(err);
    } finally {
      setLoader(false);
    }
  };

  const handleDeletePreference = (course) => {
    setSelectedPreference(course);
    setIsConfirmDeleteOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await deletePreference(auth_token, selectedPreference?.id);
      setIsConfirmDeleteOpen(false);
      await fetchPreferenceData();
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    setHeaderName("Preference");
    setIsShowSearch(true);
  }, []);

  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearch(searchQuery), 300);
    return () => clearTimeout(t);
  }, [searchQuery]);

  useEffect(() => {
    fetchPreferenceData();
  }, [debouncedSearch, page, limit]);

  return (
    <div className="preference-container">
      {loader && <GlobalLoader visible={loader} />}
      <div className="preference-header-actions"></div>
      <div className="preference-grid">
        <div
          className="preference-card preference-add-course-card"
          onClick={() => {
            setIsShowCreatePreference(true);
          }}
        >
          <div className="preference-course-card-body">
            <AddCircleOutlineOutlinedIcon className="preference-add-course-icon" />
            <h3 className="preference-course-title">Add Preference</h3>
          </div>
        </div>
        {preferenceList?.map((preference, index) => (
          <CourseCard
            key={index}
            preferenceStatus={true}
            course={preference}
            onEdit={handleEditPreference}
            onDelete={handleDeletePreference}
            handleNavigate={async () => {
              setIsShowCreatePreference(true);
              setLoader(true);
              try {
                const res = await getOnePreference(auth_token, preference?.id);
                setEditableData(res);
                setIsViewable(true);
              } catch (err) {
                console.error(err);
              } finally {
                setLoader(false);
              }
            }}
          />
        ))}
      </div>

      {isShowCreatePreference && (
        <CreatePreference
          isOpen={isShowCreatePreference}
          intialData={editableData}
          onClose={() => {
            setIsShowCreatePreference(false);
            setEditableData([]);
            setIsViewable(false);
          }}
          isViewStatus={isViewable}
          setIsViewable={setIsViewable}
          onSave={async (payload) => {
            console.log("Submitting payload:", payload);
            if (isEditable) {
              setLoader(true);
              try {
                const update = await updatePreference(
                  auth_token,
                  payload,
                  editableData?.id
                );
              } catch (err) {
                console.error(err);
              } finally {
                setEditableData([]);
                setIsEditable(false);
              }
            } else {
              setLoader(true);
              try {
                const res = await createPreference(auth_token, payload);
                console.log(res);
              } catch (err) {
                console.error(err);
              } finally {
                setEditableData([]);
                setIsEditable(false);
              }
            }
            await fetchPreferenceData();
            setIsShowCreatePreference(false);
          }}
        />
      )}
      {isConfirmDeleteOpen && (
        <DeleteConfirmPopUp
          isConfirmDeleteOpen={isConfirmDeleteOpen}
          setIsConfirmDeleteOpen={setIsConfirmDeleteOpen}
          handleDelete={handleConfirmDelete}
        />
      )}
    </div>
  );
};

export default Preference;
